import AxiosClient from "@evercam/shared/api/client/axios"

export default (app) => {
  app.provide("axios", AxiosClient)
}
